import React from 'react'
import { func, instanceOf } from 'prop-types'
import cloneDeep from 'lodash/cloneDeep';
import makeStyles from '@material-ui/core/styles/makeStyles'
import Slider from '@material-ui/core/Slider';
import { INDEX_GROUPS } from './MapsConstant'

const useStyles = makeStyles({
  root: {
    color: '#C4C4C4',
    marginBottom: 5,
  },
  markLabel: {
    fontSize: 12,
  }
})

const MapIndexGroupSettings = ({
  mapSettings,
  runReport,
  updateMapSettings,
}) => {
  const classes = useStyles();

  function valuetext(value) {
    return `${value}°C`;
  }
  
  function valueLabelFormat(value) {
    return INDEX_GROUPS.findIndex((mark) => mark.value === value) + 1;
  }

  const _updateIndexGroups = val => {
    // call api to get values for selected number of index groups
    let updatedMapSettings = cloneDeep(mapSettings)
    updatedMapSettings = {
      ...updatedMapSettings,
      indexGroupCount: val,
    }
    updateMapSettings('indexGroupCount', val)
    runReport(undefined, undefined, undefined, undefined, updatedMapSettings)
  }

  return (
    <div className="map--settings-indexGrp">
      <div className="map--settings-indexGrp__title">Index groups</div>
      <div className="map--settings-indexGrp__slider">
        <Slider
          id="slider"
          defaultValue={mapSettings.indexGroupCount}
          className={classes.root}
          valueLabelFormat={valueLabelFormat}
          getAriaValueText={valuetext}
          aria-labelledby="discrete-slider-restrict"
          step={null}
          valueLabelDisplay="off"
          marks={INDEX_GROUPS}
          track={false}
          min={3}
          max={7}
          classes={{
            markLabel: classes.markLabel
          }}
          onChangeCommitted={(e, val) => _updateIndexGroups(val)}
          onBlur={() => {}}
        />
      </div>
    </div>
  )
}

MapIndexGroupSettings.propTypes = {
  mapSettings: instanceOf(Object),
  runReport: func,
  updateMapSettings: func,
}

export default MapIndexGroupSettings;
